import { Actions, createNamespace } from "../../../../flux/Actions";
import { Division } from "../../../../models";

const ns = createNamespace('CurrentDivision');
export const names = {
    SET_TARGET_DIVISION: ns('SET_TARGET_DIVISION')
}

export interface SetTargetPayload
{
    targetDivisionId: number;
    allDivisions: Division[];
}

export class CurrentDivisionActions extends Actions
{
    setTarget = (id: number, allDivisions?: Division[]) => this.dispatch(names.SET_TARGET_DIVISION, { targetDivisionId: id, allDivisions });
}


// WEBPACK FOOTER //
// ./src/app/components/DivisionPath/flux/CurrentDivisionActions.ts